import React from 'react';
import { connect } from 'react-redux'

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import SelectDropdown from '../../Components/SelectDropdown';
import { TextFieldHelper, SelectFieldWrapperExtended, SelectFieldWrapper } from '../../Components/Fields';
import { doPost } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import DatePickerContainer from '../../Components/DatePickerContainer';

const ENDPOINT = "mitarbeiterBeschaeftigung"

export const Fields = ({handleChange, type, abteilung, betriebsstaette, datum, notiz}) => (
    <Grid container spacing={8}>

        <SelectFieldWrapper n={4} name="Typ">
            <Select
                key={type+"anrede"}
                value={type}
                onChange={handleChange('type')}
                inputProps={{
                    id: type,
                }}
                autoWidth
            >
                <MenuItem value={1}>Eintritt</MenuItem>
                <MenuItem value={2}>Austritt</MenuItem>
            </Select>
        </SelectFieldWrapper>

        <Grid item xs={8}>
            <DatePickerContainer
                dateInput
                label="Datum"
                value={datum}
                onChange={handleChange('datum')}
            />
        </Grid>

        {type !== undefined && type===1 &&
            <Grid item xs={12}>
                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <SelectDropdown
                            isMulti={false}
                            name="Betriebsstätte"
                            value={betriebsstaette && betriebsstaette.name && {label: betriebsstaette.name, ...betriebsstaette}}
                            handleChange={handleChange("betriebsstaette")}
                            placeholder="Betriebsstätte auswählen"
                            redux={"betriebsstaetten"}
                            uri={"betriebsstaetten"}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectDropdown
                            isMulti={false}
                            name="Abteilung"
                            value={abteilung && abteilung.name && {label: abteilung.name, ...abteilung}}
                            handleChange={handleChange("abteilung")}
                            placeholder="Abteilung auswählen"
                            redux={"abteilungen"}
                            uri={"abteilungen"}
                        />
                    </Grid>
                </Grid>
            </Grid>
        }

        <TextFieldHelper n={12} value={notiz} onChange={handleChange('notiz')} label="Kommentar" />

    </Grid>
)

class NewEntry extends Master {

	state = {
		newEntry: {}
	}

    componentDidMount() {
        this.state.newEntry.mitarbeiter = {id: this.props.mitarbeiterId}
        this.state.newEntry.type = 1
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(nextProps.dialogOpen !== this.props.dialogOpen) {
            this.state.newEntry.type = 1
        }
        return true
    }

    _postData = () => {

        var {
            type, abteilung, betriebsstaette, datum
        } = this.state.newEntry

        if(type === 1) {
            if(!abteilung || !betriebsstaette) {
                alert("Betriebsstätte und Abteilung muss ausgewählt sein.")
                return
            }
        }

        if(datum === undefined) {
            alert("Bitte Datum auswählen")
            return
        }

        this.state.newEntry.mitarbeiter = {id: this.props.mitarbeiterId}
        this.postData()

    }

	render() {

		var {
			handleClickOpen, dialogOpen
		} = this.props

        var {
        	newEntry
        } = this.state

        console.log("render", newEntry.type)

		return (
			<Dialog
                title="Neuer Eintrag"
                saveAction={this._postData}
                closeAction={handleClickOpen}
                open={dialogOpen}
             >
				<Fields handleChange={this.handleChange} {...newEntry} />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/" + ENDPOINT, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/MitarbeiterAnstellung/NewEntry.js